module.exports = __webpack_public_path__ + "static/media/galerija_2014 (6).338c6187.jpg";